import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import GasesLogo from "../images/gases-logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => document.body.classList.remove("overflow-hidden");
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Navbar */}
      <nav
        className={`bg-white grid grid-cols-2 md:grid-cols-3 items-center px-4 md:px-14 py-4 w-full fixed z-50 transition-all ${
          isOpen
            ? "border-none"
            : scrolled
            ? "shadow-md"
            : ""
        }`}
      >
        {/* Logo & Brand Name */}
        <div className="flex items-center">
          <img src={GasesLogo} alt="Logo" className="md:h-10 h-10" />
          <span className="text-2xl font-semibold text-gray-800 tracking-wide text-nowrap italic">
            Gases Dex
          </span>
        </div>

        {/* Desktop Navigation */}
        <ul className="hidden md:flex gap-8 text-xl justify-center">
          {["Home", "Products", "Partners"].map((item, index) => (
            <li
              key={index}
              className="hover:text-blue-900 transition-all cursor-pointer text-gray-600"
            >
              <Link to={`/${item.toLowerCase()}`}>{item}</Link>
            </li>
          ))}
        </ul>

        {/* Right-side buttons (Contact + Mobile Menu Toggle) */}
        <div className="flex justify-end ml-auto">
          {/* Contact Button */}
          <Link
            to="/contact"
            className="hidden md:inline-block px-6 py-2 text-xl text-gray-700 hover:text-blue-900 rounded-lg transition-all"
          >
            Contact Us
          </Link>

          {/* Toggle Menu Button (Switches between Menu & X) */}
          <button className="md:hidden ml-4" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? (
              <X size={24} className="text-gray-800" />
            ) : (
              <Menu size={24} className="text-gray-800" />
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Navigation Drawer (Under Navbar) */}
      <div
        className={`fixed top-16 right-0 w-full h-[calc(100vh-4rem)] font-semibold bg-gray-50 transform transition-transform duration-300 z-40  ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Mobile Menu Links */}
        <ul className="flex flex-col h-full text-lg text-gray-700">
          {["Home", "Products", "Partners"].map((item, index) => (
            <li
              key={index}
              className="p-6 border-b border-gray-300 cursor-pointer"
              onClick={() => setIsOpen(false)}
            >
              <Link
                to={`/${item.toLowerCase()}`}
                className="block w-full h-full transition-all"
              >
                {item}
              </Link>
            </li>
          ))}

          {/* Mobile Contact Button (No border) */}
          <li className="p-6 cursor-pointer" onClick={() => setIsOpen(false)}>
            <Link
              to="/contact"
              className="block w-full h-full text-lg text-gray-700 font-semibold transition-all"
            >
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
